<template>
  <div>
    <v-alert type="info" text>
      Hier könen die Start- und Endzeiten für das Onboarding der zukünftigen
      Schüler:innen (GYM0) und der aktuellen Schüler:innen (GYM1-GYM4)
      eingestellt werden.
    </v-alert>
    <v-row>
      <v-col>
        <v-card>
          <v-system-bar>GYM0</v-system-bar>
          <v-card-text>
            Start- und Endzeiten fürs Onboarding der zukünftigen Schüler:innen.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title
            >aktueller Zeitraum:<v-spacer> </v-spacer>
            <DateSpan :value="[settings.startFuture, settings.endFuture]" />
          </v-card-title>
          <v-divider></v-divider>
          <SettingsComponent
            description="Start"
            :settings="settings"
            field="startFuture"
            :loading="loading"
            @updated="fetchData"
          />
          <SettingsComponent
            description="Ende"
            :settings="settings"
            field="endFuture"
            :loading="loading"
            @updated="fetchData"
          />
        </v-card>
      </v-col>
      <v-col>
        <v-card>
          <v-system-bar>GYM1-GYM4</v-system-bar>
          <v-card-text>
            Start- und Endzeiten fürs Onboarding der aktuellen Schüler:innen.
          </v-card-text>

          <v-divider></v-divider>
          <v-card-title
            >aktueller Zeitraum:<v-spacer> </v-spacer>
            <DateSpan :value="[settings.startPresent, settings.endPresent]" />
          </v-card-title>
          <v-divider></v-divider>

          <SettingsComponent
            description="Start"
            :settings="settings"
            field="startPresent"
            :loading="loading"
            @updated="fetchData"
          />
          <SettingsComponent
            description="Ende"
            :settings="settings"
            field="endPresent"
            :loading="loading"
            @updated="fetchData"
          />
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import SettingsComponent from "./components/SettingComponent.vue";
import DateSpan from "common/components/DateSpan.vue";

export default defineComponent({
  name: "OnBoardingSettings",
  components: { DateSpan, SettingsComponent },
  props: ["search"],
  data() {
    return {
      loading: false,
      saving: false,
      settings: {},
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.settings = await this.apiList({ resource: "onboarding/settings" });
      this.loading = false;
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
